export enum ContactType {
  PROVIDERS = 1,
  NON_PROVIDERS = 4,
  VOLUNTEERS = 5,
}



// WEBPACK FOOTER //
// ./src/models/company-resources/contact-type.ts